// eslint-disable-next-line import/prefer-default-export
export const splitName = (name: string) => {
    const [firstName, ...lastName] = name.split(" ").filter(Boolean)

    return {
        firstName: firstName || undefined,
        lastName: lastName.join(" ") || undefined
    }
}
